import { motion } from 'framer-motion'
import { useNavigate } from 'react-router-dom'
import {
  Avatar,
  AvatarGroup,
  Button,
  Heading,
  HStack,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react'

import { TeamInvite } from '@pkg/types/team'

import {
  useAllReceivedTeamInvites,
  useDeclineTeamInvite,
  useTeamInvite,
} from '@/react-query/team-invites'

export const ReceivedTeamInvites = () => {
  const { data: teamInvites } = useAllReceivedTeamInvites()

  if (!teamInvites?.length) {
    return null
  }

  return (
    <VStack alignItems={'flex-start'} mt={20} spacing={6}>
      <Heading fontSize={'24px'} fontWeight={600}>
        You have been invited
      </Heading>
      <VStack spacing={4}>
        {teamInvites.map((teamInvite) => (
          <ReceivedTeamInvite key={teamInvite.id} teamInvite={teamInvite} />
        ))}
      </VStack>
    </VStack>
  )
}

const ReceivedTeamInvite = ({ teamInvite }: { teamInvite: TeamInvite }) => {
  const navigate = useNavigate()
  const declineTeamInvite = useDeclineTeamInvite(teamInvite.id)

  // this line is just a hack to preload the team invite data,
  // so when the user clicks on the accept button, the data is already loaded,
  // and the modal doesn't have to wait for the data to load.
  useTeamInvite(teamInvite.id)

  return (
    <Stack
      spacing={{
        base: 4,
        md: 16,
      }}
      as={motion.div}
      animate={{ opacity: 1 }}
      initial={{ opacity: 0 }}
      direction={{
        base: 'column',
        md: 'row',
      }}
      alignItems={{
        base: 'flex-start',
        md: 'center',
      }}
    >
      <HStack spacing={10}>
        <Text fontWeight={500} fontSize={'16px'}>
          {teamInvite.teamName}
        </Text>
        <AvatarGroup size="md" max={5}>
          {teamInvite.teamMembers.map((member) => (
            <Avatar
              key={member.displayName}
              name={member.displayName}
              src={member.photoURL}
            />
          ))}
        </AvatarGroup>
      </HStack>
      <Stack
        flexWrap={'wrap'}
        justifyContent={'flex-start'}
        alignItems={'flex-start'}
        direction={'row'}
        spacing={4}
      >
        <Button
          variant={'brand-solid'}
          onClick={() => {
            navigate(`/team/${teamInvite.id}`)
          }}
        >
          Accept invitation
        </Button>
        <Button
          variant={'brand-solid-gray'}
          onClick={() => {
            declineTeamInvite.mutate()
          }}
          isLoading={declineTeamInvite.isPending}
        >
          Decline
        </Button>
      </Stack>
    </Stack>
  )
}
